(function () {
  var POPUP_ROOT = "[data-hotspot-modal-quickshop], .hotspot__modal";

  function isInPopup(node) {
    return !!(node && node.closest && node.closest(POPUP_ROOT));
  }

  function isExplicitNo(val, text) {
    var v = (val || "").toString().toLowerCase().trim();
    var t = (text || "").toString().toLowerCase().trim();
    if (!v || v === "--" || v === "-" || t === "--" || t.indexOf("--") === 0) {
      return false;
    }
    return v.indexOf("no") === 0 || t.indexOf("no") === 0;
  }

  function isUnselected(select) {
    var val = (select.value || "").toString().toLowerCase().trim();
    var opt = select.options[select.selectedIndex];
    var text = opt ? (opt.text || "").toString().toLowerCase().trim() : "";

    if (opt && (opt.classList.contains("default-placeholder-option") || opt.disabled)) {
      return true;
    }
    if (!val || val === "not-selected" || val === "false" || val === "--" || val === "-") {
      return true;
    }
    if (
      text === "--" ||
      text === "-" ||
      text.indexOf("--") === 0 ||
      text.indexOf("choose") > -1 ||
      text.indexOf("select") > -1
    ) {
      return true;
    }
    return false;
  }

  function getOptionLabel(select) {
    var wrap = select.closest(".options-selection__select");
    if (!wrap) return "this option";
    var labelEl = wrap.querySelector(".options-selection__select-label");
    var label = labelEl
      ? labelEl.getAttribute("data-variant-option-name") || labelEl.textContent
      : "";
    if (!label) {
      label = wrap.querySelector("label") ? wrap.querySelector("label").textContent : "";
    }
    return (label || "this option").trim();
  }

  function cleanPlaceholderSelect(select) {
    if (!select) return;

    var def = select.querySelector(".default-placeholder-option");
    if (def) {
      var t = def.textContent || "";
      if (t.indexOf("Unavailable") > -1 || t.indexOf(" - ") > -1) {
        def.textContent = "--";
      }
    }

    if (!select.value || select.value === "not-selected") {
      select.selectedIndex = 0;
    }

    if (select._cantaloupeObserved) return;
    select._cantaloupeObserved = true;

    new MutationObserver(function () {
      var d = select.querySelector(".default-placeholder-option");
      if (d) {
        var txt = d.textContent || "";
        if (txt.indexOf("Unavailable") > -1) {
          d.textContent = "--";
        }
      }
      if (!select.value || select.value === "not-selected") {
        select.selectedIndex = 0;
      }
    }).observe(select, { childList: true, subtree: true, characterData: true });
  }

  function tagSpecialDropdowns(formArea) {
    formArea.querySelectorAll("select[data-variant-option]").forEach(function (select) {
      if (select.classList.contains("new-customer-select")) return;

      var wrap = select.closest(".options-selection__select");
      var labelText = "";
      if (wrap) {
        var lbl = wrap.querySelector("label, .options-selection__select-label");
        labelText = lbl ? lbl.textContent : "";
      }
      var combined = (
        (select.id || "") +
        " " +
        (select.getAttribute("data-option-name") || "") +
        " " +
        labelText
      ).toLowerCase();

      if (
        combined.indexOf("existing") > -1 ||
        combined.indexOf("customer") > -1 ||
        combined.indexOf("fees") > -1 ||
        combined.indexOf("rates") > -1 ||
        combined.indexOf("acknowledged") > -1
      ) {
        select.classList.add("new-customer-select");
        select.setAttribute("data-special-dropdown", "true");
      }
    });
  }

  function getAtcButton(formArea) {
    return (
      formArea.querySelector(".product-form--atc-button") ||
      formArea.querySelector("button[type='submit'][name='add']")
    );
  }

  function ensureErrorEl(formArea) {
    var msg = formArea.querySelector(".variant-error-message");
    if (msg) return msg;
    var btn = getAtcButton(formArea);
    if (!btn) return null;
    msg = document.createElement("p");
    msg.className = "variant-error-message";
    msg.style.cssText = "display:none;color:#c0392b;font-size:14px;font-weight:600;margin-top:10px;width:100%;";
    btn.insertAdjacentElement("afterend", msg);
    return msg;
  }

  function showError(formArea, label) {
    var msg = ensureErrorEl(formArea);
    if (msg) {
      msg.textContent = "Please select an option for " + label;
      msg.style.display = "block";
    }
  }

  function hideError(formArea) {
    var msg = formArea.querySelector(".variant-error-message");
    if (msg) msg.style.display = "none";
  }

  function validateFormArea(formArea) {
    var special = formArea.querySelectorAll(
      ".new-customer-select, select[data-special-dropdown='true']"
    );
    var i;
    for (i = 0; i < special.length; i++) {
      if (isUnselected(special[i])) {
        special[i].focus();
        return { valid: false, label: getOptionLabel(special[i]) };
      }
    }

    var options = formArea.querySelectorAll("select[data-variant-option]");
    for (i = 0; i < options.length; i++) {
      if (options[i].classList.contains("new-customer-select")) continue;
      if (isUnselected(options[i])) {
        options[i].focus();
        return { valid: false, label: getOptionLabel(options[i]) };
      }
    }

    return { valid: true, label: "" };
  }

  function updateAtcButton(formArea) {
    var btn = getAtcButton(formArea);
    if (!btn) return;

    var hasNo = false;
    formArea.querySelectorAll(".new-customer-select").forEach(function (select) {
      var opt = select.options[select.selectedIndex];
      if (isExplicitNo(select.value, opt ? opt.text : "")) {
        hasNo = true;
      }
    });

    var textEl = btn.querySelector(".atc-button--text");

    if (hasNo) {
      btn.classList.add("disabled");
      btn.disabled = true;
      btn.style.backgroundColor = "#999";
      btn.style.opacity = "0.6";
      btn.style.cursor = "not-allowed";
      btn.style.pointerEvents = "none";
      if (textEl) textEl.textContent = "Unavailable";
      else btn.textContent = "Unavailable";
    } else {
      btn.classList.remove("disabled");
      btn.disabled = false;
      btn.style.backgroundColor = "";
      btn.style.opacity = "";
      btn.style.cursor = "";
      btn.style.pointerEvents = "";
      if (textEl) textEl.textContent = "Add to cart";
      else btn.textContent = "Add to cart";
    }
  }

  function findCustomerPopup(formArea) {
    if (formArea) {
      var inForm = formArea.querySelector(".custom-model-main");
      if (inForm) return inForm;
    }
    var inPopup = document.querySelector(POPUP_ROOT + " .custom-model-main");
    if (inPopup) return inPopup;
    return null;
  }

  function mountCustomerPopup(popup) {
    if (!popup || popup._cantaloupeMountedOnBody) return;
    popup._cantaloupeMountedOnBody = true;
    popup._cantaloupeOriginalParent = popup.parentNode;
    document.body.appendChild(popup);
  }

  function openExistingCustomerPopup(formArea) {
    var popup = findCustomerPopup(formArea);
    if (!popup) return;

    mountCustomerPopup(popup);
    document.body.classList.add("no-scroll");
    popup.style.display = "";
    popup.classList.add("model-open");
    popup.classList.add("hotspot-customer-popup");

    var existing = popup.querySelector(".existing-customer");
    if (existing) existing.style.display = "block";

    popup.querySelectorAll(".vdi-set-up, .two-tier-pricing, .login-form").forEach(function (el) {
      el.style.display = "none";
    });

    bindInquiryLinks(popup);
  }

  function closeCustomerPopup(popup) {
    if (!popup) return;
    popup.classList.remove("model-open");
    document.body.classList.remove("no-scroll");
  }

  var MKTO_BASE = "//go.cantaloupe.com";
  var MKTO_MUNCHKIN = "215-UDK-725";
  var MKTO_FORM_ID = 4184;

  function ensureMktoForms2(callback) {
    if (typeof MktoForms2 !== "undefined") {
      callback();
      return;
    }
    var existing = document.querySelector('script[src*="forms2.min.js"]');
    if (existing) {
      if (existing.getAttribute("data-loaded") === "true") {
        callback();
      } else {
        existing.addEventListener("load", callback, { once: true });
      }
      return;
    }
    var script = document.createElement("script");
    script.src = MKTO_BASE + "/js/forms2/js/forms2.min.js";
    script.addEventListener(
      "load",
      function () {
        script.setAttribute("data-loaded", "true");
        callback();
      },
      { once: true }
    );
    document.head.appendChild(script);
  }

  function ensureMktoFormMount() {
    if (document.getElementById("mktoForm_" + MKTO_FORM_ID)) return;
    var mount = document.createElement("div");
    mount.id = "cantaloupe-mkto-inquiry-mount";
    mount.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;";
    mount.innerHTML = '<form id="mktoForm_' + MKTO_FORM_ID + '"></form>';
    document.body.appendChild(mount);
  }

  function showInquiryLightbox() {
    ensureMktoFormMount();

    ensureMktoForms2(function () {
      function showLightbox(form) {
        if (!form || !window.MktoForms2) return;
        MktoForms2.lightbox(form).show();
        document.body.classList.add("no-scroll");
      }

      function openForm() {
        var existingForm = MktoForms2.getForm(MKTO_FORM_ID);
        if (existingForm) {
          showLightbox(existingForm);
          return;
        }

        MktoForms2.loadForm(MKTO_BASE, MKTO_MUNCHKIN, MKTO_FORM_ID, showLightbox);
      }

      if (typeof MktoForms2.whenReady === "function") {
        MktoForms2.whenReady(openForm);
      } else {
        openForm();
      }
    });
  }

  function openInquiryForm(popup) {
    if (popup) {
      popup.classList.remove("model-open");
      popup.style.display = "none";
    }
    document.body.classList.remove("no-scroll");
    showInquiryLightbox();
  }

  function bindInquiryLinks(popup) {
    if (!popup) return;

    popup.querySelectorAll(".existing-customer p a, .existing-customer p a strong").forEach(function (node) {
      if (node._cantaloupeInquiryBound) return;
      node._cantaloupeInquiryBound = true;

      if (node.tagName === "A") {
        node.setAttribute("href", "javascript:void(0)");
        node.setAttribute("role", "button");
      }

      node.style.cursor = "pointer";

      node.addEventListener(
        "click",
        function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
          openInquiryForm(popup);
          return false;
        },
        true
      );
    });
  }

  function toggleYesMessage(select) {
    var wrap = select.closest(".options-selection__select");
    if (!wrap) return;
    var messageDiv = wrap.querySelector(".existing-customer-message");
    if (!messageDiv) return;
    var val = (select.value || "").toLowerCase().trim();
    messageDiv.style.display = val.indexOf("yes") === 0 ? "block" : "none";
  }

  function watchAtcButton(formArea) {
    var btn = getAtcButton(formArea);
    if (!btn || btn._cantaloupeBtnWatch) return;
    btn._cantaloupeBtnWatch = true;

    new MutationObserver(function () {
      var textEl = btn.querySelector(".atc-button--text");
      var label = textEl ? textEl.textContent : btn.textContent;
      if (btn.disabled && label && label.toLowerCase().indexOf("sold out") > -1) {
        updateAtcButton(formArea);
      }
    }).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
  }

  function schedulePopupRefresh(formArea) {
    [400, 900, 1500, 2500, 4000].forEach(function (ms) {
      setTimeout(function () {
        initPopupFormArea(formArea);
      }, ms);
    });
  }

  function initPopupFormArea(formArea) {
    if (!formArea) return;
    tagSpecialDropdowns(formArea);
    formArea.querySelectorAll(".new-customer-select, select[data-special-dropdown='true']").forEach(cleanPlaceholderSelect);
    ensureErrorEl(formArea);
    updateAtcButton(formArea);
    watchAtcButton(formArea);
    bindInquiryLinks(findCustomerPopup(formArea));
  }

  function initPopup() {
    var formArea = document.querySelector(POPUP_ROOT + " [data-product-form-area]");
    if (formArea) {
      initPopupFormArea(formArea);
      schedulePopupRefresh(formArea);
    }
  }

  function formNeedsValidation(form) {
    var formArea = form.closest("[data-product-form-area]");
    if (!formArea || !isInPopup(formArea)) return false;
    return !!formArea.querySelector("select[data-variant-option], .new-customer-select");
  }

  /* --- Global handlers (registered once) --- */
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches("[data-product-form]")) return;
      if (!formNeedsValidation(form)) return;

      var formArea = form.closest("[data-product-form-area]");
      var result = validateFormArea(formArea);
      if (!result.valid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showError(formArea, result.label);
        return false;
      }
      hideError(formArea);
    },
    true
  );

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".product-form--atc-button, button[type='submit'][name='add']");
    if (!btn || !isInPopup(btn)) return;

    var formArea = btn.closest("[data-product-form-area]");
    if (!formArea) return;

    var result = validateFormArea(formArea);
    if (!result.valid) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showError(formArea, result.label);
    }
  });

  document.addEventListener("change", function (e) {
    var select = e.target;
    if (!select.matches || !select.matches("select")) return;
    if (!isInPopup(select)) return;

    var formArea = select.closest("[data-product-form-area]");
    if (!formArea) return;

    updateAtcButton(formArea);

    if (select.classList.contains("new-customer-select") || select.getAttribute("data-special-dropdown") === "true") {
      toggleYesMessage(select);
      var opt = select.options[select.selectedIndex];
      if (isExplicitNo(select.value, opt ? opt.text : "")) {
        openExistingCustomerPopup(formArea);
      }
    }

    if (validateFormArea(formArea).valid) {
      hideError(formArea);
    }
  });

  document.addEventListener("click", function (e) {
    var closeTarget = e.target.closest(".custom-model-main .close-btn, .custom-model-main .bg-overlay");
    if (!closeTarget) return;
    var popup = closeTarget.closest(".custom-model-main");
    if (!popup || !popup.classList.contains("hotspot-customer-popup")) return;
    closeCustomerPopup(popup);
  });

  (function bindJqueryInquiryWhenReady(attempts) {
    if (window.jQuery) {
      var $ = window.jQuery;
      $(document).on(
        "click.cantaloupeInquiry",
        ".hotspot-customer-popup.model-open .existing-customer p a strong, .hotspot-customer-popup.model-open .existing-customer p a",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          openInquiryForm($(this).closest(".custom-model-main")[0]);
          return false;
        }
      );
      return;
    }
    if (attempts < 50) {
      setTimeout(function () {
        bindJqueryInquiryWhenReady(attempts + 1);
      }, 100);
    }
  })(0);

  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-hotspot], .hotspot__tooltip, [data-hotspot-modal-sidebar-item]")) return;
    setTimeout(initPopup, 400);
    setTimeout(initPopup, 1000);
    setTimeout(initPopup, 2000);
  });

  var quickshopNode = document.querySelector("[data-hotspot-modal-quickshop]");
  if (quickshopNode) {
    new MutationObserver(function () {
      if (document.querySelector(POPUP_ROOT + " [data-product-form-area]")) {
        setTimeout(initPopup, 300);
        setTimeout(initPopup, 900);
        setTimeout(initPopup, 1800);
      }
    }).observe(quickshopNode, { childList: true, subtree: true });
  }

  /* --- Original product-page logic (VDI / service fee) --- */
  document.addEventListener("DOMContentLoaded", function () {
    var serviceDropdown = document.querySelector(
      'select[data-option-name="carrier-monthly-service-fee-and-processing-rate"]'
    );
    var vdiDropdown = document.querySelector("#do-you-want-vdi-set-up");

    if (serviceDropdown && vdiDropdown && window.jQuery) {
      var $ = window.jQuery;
      if (serviceDropdown.value.includes("Cashless Plus")) {
        vdiDropdown.value = "Yes";
        $("#do-you-want-vdi-set-up option[value='No']").hide();
        $("#vdi-setup").attr("value", "");
        $("#vdi-setup").attr("name", "properties[VDI Setup]");
      }

      serviceDropdown.addEventListener("change", function () {
        if (serviceDropdown.value.includes("Cashless Plus")) {
          vdiDropdown.value = "Yes";
          $("#do-you-want-vdi-set-up option[value='No']").hide();
          $("#vdi-setup").attr("value", "");
          $("#vdi-setup").attr("name", "properties[VDI Setup]");
        } else {
          $("#do-you-want-vdi-set-up option[value='No']").show();
          vdiDropdown.value = "No";
          $("#vdi-setup").removeAttr("name");
        }
      });
    }

    document.querySelectorAll('select[data-variant-option]').forEach(function (select) {
      if (!isInPopup(select)) {
        bindExistingCustomerMessage(select);
      }
    });
  });

  function bindExistingCustomerMessage(select) {
    var label = select.parentElement && select.parentElement.parentElement
      ? select.parentElement.parentElement.querySelector("label")
      : null;
    if (!label || label.innerText.indexOf("Are you an existing customer?") === -1) return;

    select.addEventListener("change", function () {
      toggleYesMessage(select);
    });
  }
})();
